import { isUserLoggedIn } from '../utils/user';
import { initialState as signIn } from '../reducers/SignIn';
import { getPersistedError, removePersistedError } from '../utils/errors';

export default async () => {
  const loggedIn = await isUserLoggedIn();
  const state = { loggedIn };

  const persistedSignInError = getPersistedError('signIn');
  if (persistedSignInError) {
    state.signIn = { ...signIn, error: { type: persistedSignInError } };
    removePersistedError('signIn');
  }

  return state;
};
